// extracted by mini-css-extract-plugin
export default {"fieldsList":"FormElements_fieldsList__Vjvar","fieldsListItem":"FormElements_fieldsListItem__PmzY8"};